<template>
  <!-- Top nav -->
  <header class="topnav">
    <div class="nav-inner">
      <div @click="goHome" class="logo">
        <img src="../assets/imgs/schrain-logo.png" alt="">
      </div>
      <nav class="menu">
        <div class="product-block" @mouseenter="onEnter" @mouseleave="onLeave">
          <div @click="goPd" class="text nav-text" :class="{ active: activeName === 'Products' }">PRODUCTS</div>
          <!-- <img class="products-arrow" :class="{ rotate: showArrowBlock }" src="../assets/images/products-arrow.svg" alt="" /> -->
        </div>
        <div @click="goWhy" class="nav-text" :class="{ active: activeName === 'whyus' }">WHY SCHRAIN</div>
        <!-- <div @click="goStory" class="nav-text" :class="{ active: activeName === 'story' }">LEARN</div> -->
        <div @click="goSupport" class="nav-text" :class="{ active: activeName === 'Support' }">CONTACT</div>
      </nav>
      <div class="icons-list">
        <div @click="openWindow(1)" class="icon">
          <img src="../assets/imgs/icon-facebook.svg" alt="">
        </div>
        <div @click="openWindow(2)" class="icon">
          <img src="../assets/imgs/icon-youtube.svg" alt="">
        </div>
        <div @click="openWindow(3)" class="icon">
          <img src="../assets/imgs/icon-ins.svg" alt="">
        </div>
      </div>
    </div>
    <!-- <div class="arrow-down-block" :class="{ show: showArrowBlock }" @mouseenter="onEnter" @mouseleave="onLeave">
      <div class="left">
        <div class="text-1">Explore our</div>
        <div class="text-2">Excellent<br>
          Furry<br>
          Products</div>
      </div>
      <div class="right">
        <div class="product">
          <div class="pd-img">
            <img @click="goProductDetail(1)" src="../assets/images/pd1.png" alt="" />
          </div>
          <div class="text" style="padding-left: 35px;">For Dog</div>
        </div>
        <div class="product">
          <div class="pd-img">
            <img @click="goProductDetail(2)" src="../assets/images/pd2.png" alt="" />
            <img @click="goProductDetail(3)" src="../assets/images/pd3.png" alt="" />
          </div>
          <div class="text">For Cat</div>
        </div>
      </div>
    </div>
    <div class="mask" :class="{ show: showArrowBlock }"></div> -->
  </header>
</template>
<script setup>
import { ref, watch } from "vue";
const showArrowBlock = ref(false);
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const activeName = ref(route.name || '');
watch(
  () => route.name,
  (newName, oldName) => {
    if (newName && newName !== oldName) {
      activeName.value = newName;
      console.log('Route name changed:', newName);
    }
  },
  { immediate: true }
);
// const goProductDetail = (id) => {
//   onLeave()
//   router.push({ name: 'ProductDetail', query: { id } });
// }
const goPd = () => {
  router.push({ name: 'Products' })
}
const goHome = () => {
  router.push({ name: 'Home' });
}
const goWhy = () => {
  router.push({ name: 'whyus' });
}
// const goStory = () => {
//   router.push({ name: 'Ourstory' });
// }
const goSupport = () => {
  router.push({ name: 'Support' });
}
const openWindow = (index) => {
  if (index == 1) {
    window.open('https://www.facebook.com/share/1GTfXNJgyP/?mibextid=wwXIfr', "_blank")
  }
  else if (index == 2) {
    window.open('https://youtube.com/@schrain-m7k?si=QJXMeFB-wNk63Hbp', "_blank")
  }
  else {
    window.open('https://www.instagram.com/schrainpetfoods?igsh=MnZzN3RxMjVyeTUw&utm_source=qr', "_blank")
  }
}
// 鼠标进入/离开时切换状态
const onEnter = () => {
  showArrowBlock.value = true;
};
const onLeave = () => {
  showArrowBlock.value = false;
};

</script>

<style lang="scss" scoped>
.topnav {
  position: absolute;
  width: 100%;
  min-width: 1200px;
  height: 132px;
  top: 0;
  left: 0;
  background: transparent;

  .nav-inner {
    position: relative;
    box-sizing: border-box;
    display: flex;
    height: 132px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 50px;
    margin: 0 auto;
    z-index: 100;
    background: transparent;

    .menu {
      width: 50%;
      display: flex;
      color: #fff;
      font-family: "Oswald-SemiBold";
      font-size: 18px;
      line-height: 132px;
      justify-content: space-around;
      .active {
        position: relative;
        color: #e40012;
      }

      .product-block {
        position: relative;

        .products-arrow {
          position: absolute;
          top: 39px;
          right: 10px;
          width: 13px;
          cursor: pointer;
        }

        .rotate {
          transform: rotate(180deg);
        }
      }

      div {
        cursor: pointer;
        margin-right: 30px;
      }
    }

    .logo {
      cursor: pointer;
      width: 200px;
      height: auto;
    }

    .icons-list {
      width: 200px;
      display: flex;
      flex-direction: row-reverse;

      .icon {
        cursor: pointer;
        margin-left: 20px;
        width: 30px;
      }
    }
  }

  .arrow-down-block {
    position: absolute;
    display: flex;
    top: 132px;
    left: 0;
    width: 100%;
    height: 0;
    /* 初始高度 0 */
    overflow: hidden;
    /* 超出部分隐藏 */
    z-index: 100;
    background: linear-gradient(to bottom, #e4edf9, #fbfcfe);
    transition: height 0.3s ease;
    padding: 0 5%;

    &.show {
      height: 400px;
    }

    .left {
      width: 30%;
      color: #a3a9f5;
      text-align: left;
      margin-top: 50px;

      .text-1 {
        font-family: "RedHatDisplay-Regular";
        font-size: 50px;
        line-height: 1;
      }

      .text-2 {
        font-family: "RedHatDisplay-black";
        font-size: 50px;
        line-height: 1;
      }

      .text-3 {
        cursor: pointer;
        font-family: "RedHatDisplay-Medium";
        font-size: 18px;
        line-height: 40px;
        color: #fff;
        background: #a3a9f5;
        width: 150px;
        border-radius: 15px;
        height: 40px;
        text-align: center;
        margin: 20px 0 0 10px;
      }
    }

    .right {
      display: flex;
      width: 60%;
      margin-top: 50px;

      .product {
        height: 300px;
        margin-right: 0;

        .pd-img {
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            cursor: pointer;
            width: 250px;

            &:hover {
              transform: scale(1.05);
              animation: scaleUp 0.5s linear;
            }
          }
        }

        .text {
          font-family: "RedHatDisplay-Medium";
          font-size: 18px;
          line-height: 1;
          color: #212995;
          margin-top: 20px;
        }
      }
    }
  }

  .mask {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 80;

    &.show {
      display: block;
    }
  }
}

@keyframes scaleUp {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.05);
  }
}
</style>